import * as React from "react";
import { RoutingActions } from "../../../../../react-core/Flux/Variables";
import { UserClaim } from "../../../../../Wrap/Constants/Enums/UserClaim";
import { checkPermission } from "../../../../Shared/Permission/PermissionHelper";
import {
    AccountContextWizardComponent,
    IAccountContextWizardComponentState,
} from "../../../../Shared/Process/AccountContextWizardComponent";
import { Confirmation } from "../../../../Shared/Process/Process/Confirmation";
import { StepType } from "../../../../Shared/Process/Process/Process";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../Resoures/Contents";
import { AccountRoleStore, ClientAccountStore } from "../../../Stroes/Variable";
import { Urls } from "../../../Urls";
import { RestrictionStore } from "../Common/Restrictions/Variable";
import { getUrl } from "../PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { productMap } from "../SinglePaymentTransferWizard/Resource/Content";
import { SwitchAction } from "./Action/SwitchAction";
import { Review } from "./Components/Review/Review";
import { SwitchFromInvestment } from "./Components/SwitchFrom/SwitchFromInvestment";
import { SwitchToInvestment } from "./Components/SwitchTo/SwitchToInvestment";
import { switchStepperName } from "./Resource/Content";
import { SwitchStore } from "./Store/Variable";
import { HierarchyIdHelper } from "../../../../Shared/Common/HierarchyIdHelper";
import { ProcessType } from "../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { InstructionStatus } from "../../../../../Wrap/Constants/Enums/Domain/InstructionStatus";
import { SwitchOrderSetup } from "./Components/OrderSetup/SwitchOrderSetup";
interface ISwitchWizardState extends IAccountContextWizardComponentState {
    extraInfo?: any;
    isInstructionLoaded: boolean;
}
export class SwitchWizard extends AccountContextWizardComponent<ISwitchWizardState> {
    initState() {
        this.state = {
            data: null,
            errorMsg: [],
            isShowErrorMsg: false,
            isLoading: true,
            onPosting: false,
            active: true,
            isSubmitting: false,
            extraInfo: null,
            clientAccount: null,
            customer: null,
            isInstructionLoaded: false
        };
    }

    constructor(props: any) {
        super(props);
        this.subscribeToStore(SwitchStore, () => this.onStoreChange());
    }

    private onStoreChange() {
        if (SwitchStore.getActionType() == ActionType.Success) {
            const data = SwitchStore.getData();

            this.setState({
                isLoading: false,
                data: data,
                active: data?.Status === InstructionStatus.Pending || data?.Status === InstructionStatus.NotSpecified,
            });
        }
    }

    componentDidUpdate() {
        const { customer, clientAccount, data, isInstructionLoaded } = this.state;
        if (customer && clientAccount && !data && !isInstructionLoaded) {
            const id = getQueryParameters()["id"];
            const type = Number(getQueryParameters()["type"]);
            const hierarchyId = getQueryParameters()["hierarchyid"];
            const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
    
            this.setState({ isInstructionLoaded: true });
            SwitchAction.getInstruction(
                id,
                type,
                hierarchyId,
                subAccountHierarchyId,
                customer.CustomerId
            );
        }
    }
    
    saveInstruction(from, to, toUrl, params) {
        if (to == -1) {
            this.onExit();
            return;
        }

        if (!params["id"]) {
            params["id"] = this.state.data.HierarchyId;
            SwitchAction.postInstructionProcess(
                HierarchyIdHelper.generateHierarchyId(this.state.data.HierarchyId).entityId,
                ProcessType.Switch
            );
        }

        const { customer } = this.state;
        const type = Number(getQueryParameters()["type"]);
        const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];

        this.setState({ onPosting: true });
        SwitchAction.saveInstruction(
            from, 
            this.state.data,
            type, 
            customer?.CustomerId, 
            (result) => {
                this.setState({ onPosting: false });
                if (result?.length > 0) {
                    this.setState({ 
                        errorMsg: result.map(ele => ele.UserMessage), 
                        isShowErrorMsg: true 
                    });
                } else 
                {
                    if (from == 2) 
                    {
                        SwitchAction.getBatchId(result, subAccountHierarchyId);
                    }
                    Navigator.navigateTo(toUrl, {
                        queryParamsObject: params,
                        scrollAfterNavigating: true,
                    });
                }
            }
        );
    }

    onExit() {
        const accountRoles = AccountRoleStore.getAccountRoles();
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        RoutingActions.navigateTo(getUrl(clientAccount, accountRoles, "summary"));
    }

    onCancel() {
        this.onExit();
    }

    onSubmit() {
        this.setState({ isSubmitting: true, active: false, isShowErrorMsg: false, errorMsg: [] });
        
        const { data, customer, clientAccount } = this.state;
        
        SwitchAction.submitInstruction(
            data.HierarchyId,
            data.Contribution,
            customer.CustomerId,
            clientAccount.HeadClAccountId,
            () => {
                this.setState({ isSubmitting: false });
            }
        );
    }

    setStepperConfig() {
        const type = Number(getQueryParameters()["type"]);

        this.stepperConfig = [
            {
                title: switchStepperName.orderStep,
                url: Urls.get().SwitchOrderSetup,
                path: Contents.URLMap.orderSetup,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <SwitchOrderSetup {...this.getStepProps(0)} type={type} />,
            },
            {
                title: switchStepperName.switchFrom,
                url: Urls.get().SwitchFrom,
                path: Contents.URLMap.switchFrom,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: (
                    <SwitchFromInvestment
                        {...this.getStepProps(1)}
                        type={type}
                        readonly={RestrictionStore.buyDisabled() || RestrictionStore.sellDisabled()}
                    />
                ),
            },
            {
                title: switchStepperName.switchTo,
                url: Urls.get().SwitchTo,
                path: Contents.URLMap.switchTo,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: (
                    <SwitchToInvestment
                        {...this.getStepProps(2)}
                        type={type}
                        readonly={RestrictionStore.buyDisabled() || RestrictionStore.sellDisabled()}
                    />
                ),
            },
            {
                title: switchStepperName.review,
                url: Urls.get().SwitchReview,
                path: Contents.URLMap.review,
                onSubmit: () => this.onSubmit(),
                canSubmit: () => this.child[3].isValid(),
                needPrint: true,
                component: (
                    <Review
                        {...this.getStepProps(3)}
                        type={type}
                        onClearError={() => this.setState({ errorMsg: [], isShowErrorMsg: false })}
                    />
                ),
            },
            {
                title: switchStepperName.confirmation,
                url: Urls.get().SwitchConfiramation,
                path: Contents.URLMap.confirmation,
                type: StepType.Confirmation,
                component: (
                    <Confirmation
                        onExit={() => {
                            this.state.errorMsg.length > 0 || !checkPermission(UserClaim.AdviserPortalDluOrdersCanView)
                                ? Navigator.navigateToAndPreserveQueryParameters(Urls.get().SwitchReview)
                                : (window.location.href = `/clients/orders/orders.aspx?claccountid=${this.state.clientAccount?.HeadClAccountId}`);
                        }}
                        buttonLabel={this.state.errorMsg.length > 0 ? "Previous" : "Go to transactions"}
                        errorMsg={this.state.errorMsg[0]}
                        successMessage={`We've received your instruction to Switch investments for ${this.state.customer?.PersonalDetails.Name.Given} ${this.state.customer?.PersonalDetails.Name.Family} (${this.state.clientAccount?.HeadClAccountId}).`}
                        isLoading={this.state.isSubmitting}
                    />
                ),
            },
        ];
    }

    setProcessProps() {
        const processProps = super.setProcessProps();
        processProps.processTitle = "Switch investments";
        processProps.onSave = null;
        processProps.goBacktoFirst = true;
        processProps.subTitle = productMap[getQueryParameters()["type"]];
        return processProps;
    }
}
